import type { BoardCardField } from "@design-system/Board/Board.types";
import { BoardCard } from "@design-system/Board/BoardCard";
import { BoardCardLayout } from "@design-system/Board/BoardCardLayout";
import { TaskTitleEditor } from "./TaskTitleEditor";
import styles from "./TaskBoardChips.module.scss";

const NO_FIELDS: readonly BoardCardField[] = [];

interface TaskBoardDraftCardProps {
    onCreate: (title: string) => void;
    /** Ends the draft: after a create, Escape, or leaving an empty title. */
    onEnd: () => void;
    /** Enter and Escape: focus goes somewhere that outlives the draft. */
    onReturnFocus: () => void;
}

/**
 * The card a column's `+` opens: a title field. Enter (or leaving it with a
 * title) creates the task; Escape or leaving it empty drops the draft.
 */
export const TaskBoardDraftCard = ({
    onCreate,
    onEnd,
    onReturnFocus,
}: Readonly<TaskBoardDraftCardProps>) => (
    <BoardCard aria-label="New task" className={styles.taskCard}>
        <BoardCardLayout
            title={
                <TaskTitleEditor
                    initialTitle=""
                    placeholder="Create task"
                    onRename={onCreate}
                    onEnd={onEnd}
                    onReturnFocus={onReturnFocus}
                />
            }
            fields={NO_FIELDS}
        />
    </BoardCard>
);
